// Actions
export const FEATURE_FLAG_SUCCESS = "feature-flag/SUCCESS";
export const FEATURE_FLAG_REQUEST = "feature-flag/REQUEST";
export const FEATURE_FLAG_FAILURE = "feature-flag/FAILURE";

// Reducer
export const initialState = {
  data: null,
  error: null,
  loading: false
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FEATURE_FLAG_REQUEST:
      return {
        ...initialState,
        loading: true
      };
    case FEATURE_FLAG_SUCCESS:
      return {
        ...initialState,
        data: action.payload,
        loading: false
      };
    case FEATURE_FLAG_FAILURE:
      return {
        ...initialState,
        error: action.payload,
        loading: false
      };
    default:
      return state;
  }
}

// Action Creators

export const request = () => ({
  type: FEATURE_FLAG_REQUEST
});
export const success = data => ({
  type: FEATURE_FLAG_SUCCESS,
  payload: data
});
export const failure = error => ({
  type: FEATURE_FLAG_FAILURE,
  payload: error
});

// Selectors
export const getFeatureFlagData = state => {
  return state?.featureFlag?.data;
};
